@if (type === 'container') {
  @if (!box) {
    <div
      class="webform-container is-centered mobi-ui-grid"
      [class.has-background]="background === 'grey' || background === 'green'"
      [ngClass]="{
        'mobi-ui-grid': !box,
        'is-centered': field['#width'] !== 'full_width' && !box,
      }"
    >
      <div
        class="webform-container-inner mobi-ui-col-1/1"
        [class.is-background]="background === 'grey' || background === 'green'"
        [class.mobi-ui-ink-green]="background === 'green'"
        [class.mobi-ui-ink-grey]="background === 'grey'"
        [ngClass]="{
          'md:mobi-ui-col-2/3 xl:mobi-ui-col-1/2':
            field['#width'] === 'regular' || !field['#width'],
          'lg:mobi-ui-col-6/8': field['#width'] === 'wide',
        }"
      >
        @for (subfield of getContainerSubfields(field); track $index) {
          <webform-field
            [class.mobi-ui-ink-default]="background === 'grey'"
            [field]="subfield"
            (onSubmit)="submit()"
            [parentGroup]="parentGroup"
          ></webform-field>
        }
      </div>
    </div>
  }
  @if (box) {
    <div class="webform-container-box !my-[30px]">
      <webform-box
        [icon]="icon"
        class="webform-field--mobi_webform_primcalc_pdfgenerate"
        [content]="content"
      >
        <ng-template #content>
          @if (field['#title']) {
            <span
              class="!mt-0 mobi-ui-text-block-label-major !pt-0 mobi-ui-font-tisa mobi-ui-font-size-150"
            >
              {{ field['#title'] }}
            </span>
          }
          @for (subfield of getContainerSubfields(field); track $index) {
            <webform-field
              [field]="subfield"
              (onSubmit)="submit()"
              [parentGroup]="parentGroup"
            ></webform-field>
          }
        </ng-template>
      </webform-box>
    </div>
  }
}
@if (type === 'webform_flexbox') {
  <div
    class="flex-col mobi-ui-grid webform-flexbox mobi-ui-margin-y-md"
    [class.is-align-center]="field['#align_items'] === 'center'"
    [class.is-align-end]="field['#align_items'] === 'flex-end'"
    [class.is-align-stretch]="field['#align_items'] === 'stretch'"
    [class]="{ reverse: parentKey === 'hero' }"
  >
    @for (subfield of getContainerSubfields(field); track $index) {
      <webform-field
        class="mobi-ui-col-1/1"
        [class]="
          getContainerSubfields(field).length % 2 === 0
            ? 'md:mobi-ui-col-1/2'
            : 'md:mobi-ui-col-1/3'
        "
        [field]="subfield"
        [parentGroup]="parentGroup"
        (onSubmit)="submit()"
      ></webform-field>
    }
  </div>
}
